
import { useEffect, useState } from "react";
import TopBar from "../../components/TopbarNav";
import {
  ClipboardCheck,
  Truck,
  Wrench,
  DollarSign,
} from "lucide-react";
import OASidebar from "../../components/operationsAssociate/OASidebar";
import { FaEye } from "react-icons/fa";

const KpiCard = ({ title, value, icon, color, subText }) => (
  <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200 transform transition-transform duration-150 hover:scale-95 active:scale-90">
    <div className="flex items-center gap-3 text-sm text-gray-700 mb-2">
      <span className={`text-2xl text-${color}-500`}>{icon}</span>
      <h3 className={color ? `text-${color}-600 font-semibold ` : "text-gray-600"}>
        {title}
      </h3>
    </div>
    <p className="text-3xl font-bold text-gray-900">{value}</p>
    <p className="text-xs text-gray-500 mt-1">{subText}</p>
  </div>
);

export default function HeadOpsDashboard() {
  const [transportRequests, setTransportRequests] = useState([]);
  const [selectedRequest, setSelectedRequest] = useState(null)
  const [maintenanceLogs, setMaintenanceLogs] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(null);

  const [stats, setStats] = useState({
    pendingRequests: 0,
    recurringIssues: 0,
    maintenanceCost: 0,
  });

   // Pagination states
  const [transportPage, setTransportPage] = useState(1);
  const [maintenancePage, setMaintenancePage] = useState(1);
  const itemsPerPage = 5;


  // TODO: Replace with API calls
  useEffect(() => {
    // Mock data
    setTransportRequests([
  {
    id: 1,
    fullName: "John Doe",
    department: "Operations",
    purpose: "Business Meeting",
    travelFrom: "Kampala",
    travelTo: "Gulu",
    departure: "2025-08-25",
    return: "2025-08-27",
    mode: "Air",
    numTravelers: 1,
    vehicleRequired: true,
    driverRequired: true,
    accommodationNeeded: true,
    specialNotes: "Vegan meals required",
    status: "Pending",
  },
  {
    id: 2,
    fullName: "Jane Smith",
    department: "Marketing",
    purpose: "Conference",
    travelFrom: "Lira",
    travelTo: "Mbale",
    departure: "2025-08-28",
    return: "2025-08-30",
    mode: "Train",
    numTravelers: 1,
    vehicleRequired: false,
    driverRequired: false,
    accommodationNeeded: false,
    specialNotes: "",
    status: "Pending",
  },
    ]);

    setMaintenanceLogs([
      { id: "EQ-12", name: "Generator", issue: "Oil leak", cost: 200, date: "2025-08-20" },
      { id: "EQ-08", name: "Laptop Dell", issue: "Screen issue", cost: 120, date: "2025-08-19" },
    ]);

    setStats({
      pendingRequests: 2,
      recurringIssues: 5,
      maintenanceCost: 1320,
    });
  }, []);

//   const handleApprove = (id) => {
//     setTransportRequests((prev) =>
//       prev.map((r) => (r.id === id ? { ...r, status: "Approved" } : r))
//     );
//   };

    const handleApprove = (id) => {
    console.log("Approved request ID:", id);
    // TODO: Call your backend API to approve the request
    setTransportRequests((prev) =>
        prev.map((req) =>
        req.id === id ? { ...req, status: "Approved" } : req
        )
    );
    setDropdownOpen(null);
    };

    // Reject handler
    const handleReject = (id) => {
    console.log("Rejected request ID:", id);
    // TODO: Call your backend API to reject the request
    setTransportRequests((prev) =>
        prev.map((req) =>
        req.id === id ? { ...req, status: "Rejected" } : req
        )
    );
    setDropdownOpen(null);
    };

     // Pagination slices
  const transportStart = (transportPage - 1) * itemsPerPage;
  const transportPaginated = transportRequests.slice(transportStart, transportStart + itemsPerPage);
  const transportTotalPages = Math.ceil(transportRequests.length / itemsPerPage);

  const maintenanceStart = (maintenancePage - 1) * itemsPerPage;
  const maintenancePaginated = maintenanceLogs.slice(maintenanceStart, maintenanceStart + itemsPerPage);
  const maintenanceTotalPages = Math.ceil(maintenanceLogs.length / itemsPerPage);


 


  return (
    <div className="flex h-screen bg-gray-50 font-sans">
      {/* Sidebar */}
      <OASidebar />

      {/* Main Area */}
      <div className="flex flex-col flex-1 ml-64">
        <TopBar />

        <main className="flex-1 overflow-y-auto p-6 pt-12 space-y-8 mt-10">
          {/* Top Row: KPI Cards */}
          <section>
            <h1 className="text-2xl font-bold text-left mb-4">
              LOGISTICS 
            </h1>
            <div className="grid grid-cols-3 gap-4 mb-2">
              <KpiCard
                title="Pending Transport Requests"
                value={stats.pendingRequests}
                icon={<Truck className="w-6 h-6 text-orange-500" />}
                color="orange"
                subText="Requests awaiting approval"
              />
              <KpiCard
                title="Recurring Issues"
                value={stats.recurringIssues}
                icon={<Wrench className="w-6 h-6 text-red-500" />}
                color="red"
                subText="Top repeated equipment faults"
              />
              <KpiCard
                title="Maintenance Cost (This Month)"
                value={`$${stats.maintenanceCost}`}
                icon={<DollarSign className="w-6 h-6 text-green-500" />}
                color="green"
                subText="Total expenses logged"
              />
            </div>
          </section>

          {/* Pending Transport Requests */}
          <section className="bg-white shadow rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-4 text-orange-500">
              Pending Transport Requests
            </h2>
            <div className="overflow-x-auto bg-white shadow rounded-lg p-4">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-orange-100">
                <tr>
                  <th className="px-4 py-2 text-left">Traveler</th>
                  <th className="px-4 py-2 text-left">Dept</th>
                  <th className="px-4 py-2 text-left">Purpose</th>
                  <th className="px-4 py-2 text-left">From → To</th>
                  <th className="px-4 py-2 text-left">Departure</th>
                  <th className="px-4 py-2 text-left">Status</th>
                  <th className="px-4 py-2 text-left">Action</th>
                  <th className="px-4 py-2 text-left">View</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {transportRequests.map((req) => (
                  <tr key={req.id}>
                    <td className="px-4 py-2">{req.fullName}</td>
                    <td className="px-4 py-2">{req.department}</td>
                    <td className="px-4 py-2">{req.purpose}</td>
                    <td className="px-4 py-2">
                      {req.travelFrom} → {req.travelTo}
                    </td>

                    <td className="px-4 py-2 whitespace-nowrap">
                    {new Date(req.departure).toLocaleDateString("en-US", {
                        month: "short",
                        day: "numeric",
                        year: "numeric",
                    })}
                    </td>

                    {/* <td className="px-4 py-2">{req.departure}</td> */}
                    <td className="px-4 py-2">{req.status}</td>
                    <td className="px-4 py-2 space-x-2">
                      <td className="px-4 py-2 relative">
                        <button
                            onClick={() => setDropdownOpen(req.id === dropdownOpen ? null : req.id)}
                            className="px-3 py-1 bg-orange-100 text-orange-700 rounded shadow-sm hover:bg-orange-200"
                        >
                            Action
                        </button>

                        {dropdownOpen === req.id && (
                            <div className="absolute right-0 mt-2 w-28 bg-white border border-gray-200 shadow-lg rounded z-10">
                            <button
                                onClick={() => handleApprove(req.id)}
                                className="block w-full text-left px-4 py-2 text-orange-700 hover:bg-orange-100"
                            >
                                Approve
                            </button>
                            <button
                                onClick={() => handleReject(req.id)}
                                className="block w-full text-left px-4 py-2 text-red-700 hover:bg-red-100"
                            >
                                Reject
                            </button>
                            </div>
                        )}
                        </td>

                            
                     
                    </td>
                    <td className="px-4 py-2">
                      <button
                        onClick={() => setSelectedRequest(req)}
                        className="text-orange-500 hover:text-orange-700"
                      >
                        <FaEye />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

             {/* Pagination controls */}
              <div className="flex justify-center mt-4 space-x-2">
                {Array.from({ length: transportTotalPages }, (_, i) => (
                  <button
                    key={i}
                    onClick={() => setTransportPage(i + 1)}
                    className={`px-3 py-1 rounded ${
                      transportPage === i + 1
                        ? "bg-orange-500 text-white"
                        : "bg-gray-200 text-gray-700"
                    }`}
                  >
                    {i + 1}
                  </button>
                ))}
              </div>
          </div>

                 
          </section>

          {/* Equipment Maintenance Logs */}
          <section className="bg-white shadow rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-4 text-orange-500">
              Recent Equipment Maintenance Logs
            </h2>
            <div className="overflow-x-auto">
              <table className="w-full border-collapse">
                <thead className="bg-orange-100">
                  <tr>
                    <th className="px-4 py-2 text-left">Equip#</th>
                    <th className="px-4 py-2 text-left">Name</th>
                    <th className="px-4 py-2 text-left">Issue</th>
                    <th className="px-4 py-2 text-left">Cost</th>
                    <th className="px-4 py-2 text-left">Date</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {maintenanceLogs.map((log) => (
                    <tr key={log.id}>
                      <td className="px-4 py-2">{log.id}</td>
                      <td className="px-4 py-2">{log.name}</td>
                      <td className="px-4 py-2">{log.issue}</td>
                      <td className="px-4 py-2">${log.cost}</td>
                      <td className="px-4 py-2">{log.date}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

                {/* Pagination controls */}
              <div className="flex justify-center mt-4 space-x-2">
                {Array.from({ length: maintenanceTotalPages }, (_, i) => (
                  <button
                    key={i}
                    onClick={() => setMaintenancePage(i + 1)}
                    className={`px-3 py-1 rounded ${
                      maintenancePage === i + 1
                        ? "bg-orange-500 text-white"
                        : "bg-gray-200 text-gray-700"
                    }`}
                  >
                    {i + 1}
                  </button>
                ))}
              </div>
            
            </div>
          </section>
        </main>
      </div>
    </div>
  );
}
